import {
    addDependencies,
    ceilDependencies,
    create,
    divideDependencies,
    evaluateDependencies,
    multiplyDependencies,
    roundDependencies,
    subsetDependencies,
} from "mathjs/number";

// Create just the functions we need
const { evaluate } = create({
    addDependencies,
    ceilDependencies,
    roundDependencies,
    divideDependencies,
    evaluateDependencies,
    multiplyDependencies,
    subsetDependencies,
});
export class ExpressionDependencyRunner {

    public static run(expression: string, data: any) {
        if (data != null) {
            return evaluate(expression, data);
        }
        return null;
    }
}
